(function ($) {$(function(){
    // const loopPlayer1 = $('#loop-video1');
    // const loopPlayer2 = $('#loop-video2');
    const worksList = $('.director-works-list li a');
    worksList.hover(onEnter, onLeave);
    // loopPlayer1.on('canplay', function() {
    //     loopPlayer1.addClass('active')
    //     loopPlayer2.removeClass('active')
    // });
    // loopPlayer2.on('canplay', function() {
    //     loopPlayer2.addClass('active')
    //     loopPlayer1.removeClass('active')
    // });

    
    const loop = setInterval(() => {
        const $list = $('.director-works-list li a');
        const $videosContainer = $('.single #preview-player');
        const $activeVideo = $('.director-works-list li a.active')
        let index = ($list.index($activeVideo) + 1);
        let count = ($list.length);
        if ($('#open-director-gallery').length > 0) {
           count = count - 1;
        }
        index = count == index ? 0 : index;
        if (index != -1 && index < count) {
            worksList.removeClass('active');
            $($list[index]).addClass('active')
            const $matchingVideo = $videosContainer.find('video[src="'+ $($list[index]).data('video-loop') +'"]');
            if ($matchingVideo.attr('src')) {
                $matchingVideo.addClass('active');
                $matchingVideo.get(0).play();
                $videosContainer.find('video').not($matchingVideo).each(function(){
                    const $this = $(this);
                    $this.removeClass('active');
                    $this.get(0).pause();
                });
            }
        }
        // console.log(list.index('video.active'));
    }, 10000);
    function onEnter(){

        const $this = $(this);
        const $videosContainer = $('.single #preview-player');
        const $activeVideo = $videosContainer.find('video.active');
        worksList.removeClass('active');

        if ($this.data('video-loop') != $activeVideo.attr('src')) {
            const $matchingVideo = $videosContainer.find('video[src="'+ $this.data('video-loop') +'"]');
            if ($matchingVideo.attr('src')) {
                $matchingVideo.addClass('active');
                $matchingVideo.get(0).play();
                $videosContainer.find('video').not($matchingVideo).each(function(){
                    const $this = $(this);
                    $this.removeClass('active');
                    $this.get(0).pause();
                });
            }
        }

        // const $this = $(this);
        // if($this.attr('id') == 'open-director-gallery') return;
        // worksList.removeClass('active');
        // console.log('here');
        // if (loopPlayer1.get(0).paused) {
        //     if (loopPlayer2.attr('src') != $this.data('video-loop')) {
        //         setTimeout(() => { loopPlayer2.get(0).pause() }, 300);
        //         loopPlayer1.attr('src', $this.data('video-loop'));
        //     }
        // } else {
        //     if (loopPlayer1.attr('src') != $this.data('video-loop')) {
        //         setTimeout(() => { loopPlayer1.get(0).pause() }, 300);
        //         loopPlayer2.attr('src', $this.data('video-loop'));
        //     }
        // }
    }
    function onLeave(){
        if($(this).attr('id') == 'open-director-gallery') return;
        $(this).addClass('active');
    }
});}(_jQ3));

